module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-06-542f606cd965444903eec639292c5f21.svg";